import React, { useRef, useState } from "react";
import "./css/Modal.css";

interface ModalProps {
    children: React.ReactNode;
    onClose: () => void;
    className?: String;
}

const Modal: React.FC<ModalProps> = ({ children, onClose, className }) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const [moved, setMoved] = useState(false);

    const closeSafely = () => {
        setTimeout(() => {
            onClose();
        }, 0);
    };

    return (
        <div
            className="modal-overlay"
            onTouchStart={() => setMoved(false)}
            onTouchMove={() => setMoved(true)}
            onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();

                if (!moved) {
                    closeSafely();
                }
            }}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                closeSafely();
            }}
        >
            <div
                ref={modalRef}
                className={`modal-content custom-modal ${className || ""}`}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
                onTouchEnd={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
};

export default Modal;
